const initialState = {
  actions: [],
};

const actions = {
  getTbotActions({ commit }, ticketId) {
    const data = [
      {
        name: 'tbot_action_communications',
        text: 'Communications',
        icon: 'mdi-email-fast-outline',
        component: { name: 'TicketCommunicationMacros', params: { ticketId } },
        active: false,
        published: true,
      },
      {
        name: 'tbot_action_make_a_pds_payment',
        text: 'PDS Payment',
        icon: 'mdi-credit-card-outline',
        component: { name: 'TicketPDSPayment', params: { ticketId } },
        active: false,
        published: true,
      },
    ];

    commit('SET_ACTIONS', data);
  },

  setActiveAction({ commit, state }, name) {
    let actionData = [];
    actionData = state.actions.map((action) => ({
      ...action,
      active: action.name === name,
    }));
    commit('SET_ACTIONS', actionData);
  },

  resetActiveActions({ commit, state }) {
    let actionData = [];
    actionData = state.actions.map((action) => ({
      ...action,
      active: false,
    }));
    commit('SET_ACTIONS', actionData);
  },
};

const getters = {
  getActiveComponent(state) {
    return state.actions.find((item) => item.active === true);
  },
};

const mutations = {
  SET_ACTIONS(state, data) {
    state.actions = data;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters,
};
